<div
  class="otp-boxes"
  role="group"
  [class.otp-boxes-invalid]="invalid"
  [attr.aria-label]="label"
>
  @for (digit of digits; track trackByIndex(i); let i = $index; let first = $first) {
    <input
      #digitInput
      type="text"
      inputmode="numeric"
      maxlength="1"
      class="otp-box"
      [attr.autocomplete]="first ? 'one-time-code' : 'off'"
      [attr.aria-label]="'Digit {{number}}' | translate: { number: i + 1 }"
      [attr.aria-invalid]="invalid"
      [value]="digit"
      (input)="onDigitInput(i, $event)"
      (keydown)="onDigitKeydown(i, $event)"
      (paste)="onPaste($event)"
    />
  }
</div>
